import { useAuth } from './useAuth';
export function useHasToolPermission() {
    let hasPermission = false;
    const { user } = useAuth();
    if (user) {
        const userGroups = user.groups || [];
        hasPermission =
            user.email.endsWith('@conxai.com') || userGroups.includes(process.env.CUSTOMER_PROJECT_ID);
    }
    return hasPermission;
}
